import type { FaireProductEntity } from "../../entity_types/product";

export const p_cw83wmurhp: FaireProductEntity = {
  token: "p_cw83wmurhp",
  type: "product",
  name: "Sea Salt Sun Insulated Skinny Stainless Steel Summer Tumbler",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/c5f409ea9c7bec00fd9168a281777fe8f7ad717b282863db346748d92f16059a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6da5e541eafc1fb7d1ebb8398e6973a680d88dc2819b453da3589f6bf08b4d8.jpeg"
  ],
  priceDollars: 12.5,
  description: "Hello Summer! Summer is here and our tumblers make the perfect travel cup for those early mornings and late nights by the beach. Its unique and fun design makes you excited for the season and all it has to offer. Whether you’re a bride on the lookout for some witty and cute bridesmaid gifts, or you’re just looking to class up your desk at work, this summer water bottle is absolutely the solution! These custom tumblers are ideal for birthdays, anniversaries, Mother’s Day gifts, Father’s Day Gifts and of course, Christmas gifts.\n\nMaterial:\nHigh quality, food grade stainless steel. Our durable, 20-ounce tumblers contain double-wall vaccum insulation to keep contents hot and cold throughout the day. Simply fill with your favorite beverage - water, coffee, tea, wine, juice, and / or any other beverage of your choice!\n\nIncludes:\nBPA free slide-close lid and metal straw. Hand wash recommended.\n\nMeasurements:\n8.25\" Tall x 3\" Diameter",
  tags: [],
  msrpDollars: 24.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:46.174Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
